import { render, staticRenderFns } from "./CustomFormItem.vue?vue&type=template&id=ec0d5308&scoped=true"
import script from "./CustomFormItem.vue?vue&type=script&lang=js"
export * from "./CustomFormItem.vue?vue&type=script&lang=js"
import style0 from "./CustomFormItem.vue?vue&type=style&index=0&id=ec0d5308&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d5308",
  null
  
)

export default component.exports